import React from 'react'
import Layout from '../components/Layout'
import mar from '../assets/MAR.png'
import './CSS/about-policy.css'

const About = () => {
  return (
    <Layout>
      <div className='about'>
        <img src={mar} alt='logo' />
        <h3>About Us</h3>
        <p>
        Welcome to our online store, your ultimate destination for high-quality sports products! Whether you're a dedicated athlete, a fitness enthusiast, or simply someone who loves to stay active, we have everything you need to fuel your passion. Explore our extensive range of sports gear, apparel, and equipment, carefully curated to enhance your performance and elevate your sporting experience. From top-of-the-line athletic shoes to innovative fitness trackers, we offer a wide selection of products from renowned brands to ensure you're always equipped with the best tools for success. Discover the perfect balance of style, functionality, and durability as you browse through our vast collection. With our user-friendly interface, secure payment options, and reliable shipping, shopping with us is not only convenient but also a breeze. Get ready to take your sports journey to new heights with our exceptional range of sports products.
        </p>
      </div>
    </Layout>
  )
}

export default About